module.exports = __webpack_public_path__ + "static/media/REFLEJOS.c48d0084.png";